<template>
  <AConfigProvider :locale="aLocale">
    <n-message-provider>
      <router-view></router-view>
    </n-message-provider>
  </AConfigProvider>
</template>
<script lang="ts">
// import hljs from 'highlight.js/lib/core';
// import javascript from 'highlight.js/lib/languages/javascript';
</script>

<script lang="ts" setup>
import dayjs from 'dayjs';
import { ConfigProvider as AConfigProvider } from 'ant-design-vue';
import { onMounted, ref, watchEffect } from 'vue';
import 'dayjs/locale/zh-cn';
import { useUserConfigStore } from './store/useUserConfigStore';
import { storeToRefs } from 'pinia';

// hljs.registerLanguage('javascript', javascript);

dayjs.locale('zh-cn');

const userConfigStore = storeToRefs(useUserConfigStore());
const { locale: aLocale } = userConfigStore;

onMounted(() => {
  console.log(
    'This tool is developed and provided by Tianfanfan. If you have any questions please contact QQ group: 468195767, QQ 910520150.',
  );
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
}
</style>
